import React, { Fragment } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { compose, createStore, applyMiddleware } from 'redux';
import timerMiddleware from 'redux-timer-middleware';
import createSagaMiddleware from 'redux-saga';
import { connectRouter, routerMiddleware, ConnectedRouter } from 'connected-react-router';
import * as Sentry from '@sentry/react';

import createBrowserHistory from './history';
import rootReducer from './reducers';
import appStart from './sagas';
import RootRouter from './routes';
import DevTools from './components/DevTools';

import './index.css';

const sagaMiddleware = createSagaMiddleware();

const isProduction = process.env.NODE_ENV === 'production';
const history = createBrowserHistory();

export let store;
if (isProduction) {
    store = createStore(
        connectRouter(history)(rootReducer),
        compose(
            applyMiddleware(
                routerMiddleware(history),
                sagaMiddleware,
                timerMiddleware,
            ),
        ),
    );
}
else {
    // Only use the DevTools component when in development.
    const enhancer = DevTools.instrument();
    store = createStore(
        connectRouter(history)(rootReducer),
        compose(
            applyMiddleware(
                routerMiddleware(history),
                sagaMiddleware,
                timerMiddleware,
            ),
            enhancer
        ),
    );
}

const saga = sagaMiddleware.run(appStart);
saga.done.then(() => render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <Fragment>
                <Sentry.ErrorBoundary fallback={ <p>An error has occurred</p> }>
                    <RootRouter history={history}/>
                    {/*{!isProduction && <DevTools />}*/}
                </Sentry.ErrorBoundary>
            </Fragment>

        </ConnectedRouter>
    </Provider>,
    document.getElementById('app'),
));
